import {ENDPOINTS} from '../common/endpoints';
import {IAnalyticsPeriod, IOrderAnalytics} from '../models/Analytics/IOrderAnalytics';
import {baseAPI} from './BaseAPI';
import {TAGS} from './TagTypes';

export const analyticsAPI = baseAPI.injectEndpoints({
    endpoints: (build) => ({
        getOrderAnalytics: build.query<IOrderAnalytics, IAnalyticsPeriod>({
            query: (params) => ({url: ENDPOINTS.ANALYTICS.ORDERS, method: 'GET', params}),
            providesTags: [TAGS.ANALYTICS],
        }),
    }),
});
